import { render, staticRenderFns } from "./StyleDialogContent.vue?vue&type=template&id=22808172&scoped=true&"
import script from "./StyleDialogContent.vue?vue&type=script&lang=js&"
export * from "./StyleDialogContent.vue?vue&type=script&lang=js&"
import style0 from "./StyleDialogContent.vue?vue&type=style&index=0&id=22808172&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22808172",
  null
  
)

export default component.exports